globalThis.Visualizations = globalThis.Visualizations || {
  Highcharts: {},
  Tables: {},
  Composites: {}
};

window.Visualizations = globalThis.Visualizations;
